// removed by extract-text-webpack-plugin
module.exports = {"submittedSucess":"_3miC3QGN7jbwX0cGnuEJb8","submittedSucessTit":"_31C1-FT2cV8IprVxVNDsGt","submittedSucessContent":"ok_HkWZzHlWVK_tyNZUkp","bottom":"_2gB2ptW5QWuJp4QGbcKZ0s","btn":"_3F7D_VDBhVIyxV1eLglWns"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SuccessModal/SuccessModal.scss
 ** module id = 1042
 ** module chunks = 0
 **/